import { render, staticRenderFns } from "./CustomerCustomerTransactionHistory.vue?vue&type=template&id=4d2d9c54"
import script from "./CustomerCustomerTransactionHistory.vue?vue&type=script&lang=js"
export * from "./CustomerCustomerTransactionHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports